import { StyledBroadsiderInventoryItem } from './BroadsiderInventoryItem.styled';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';
import { useAudio } from '../../providers/AudioContext';

const InfoButton = ({ onClick }) => {
  const { playSFX } = useAudio();
  return (
    <div className='broadsider-inv-item-info-button' onClick={onClick} onMouseEnter={() => playSFX('hover')}>
      <div className='broadsider-inv-item-info-button-content'>
        <img src='/assets/info.svg' />
      </div>
      <div className='broadsider-inv-item-info-button-corner broadsider-inv-item-info-button-corner-l'/>
      <div className='broadsider-inv-item-info-button-corner broadsider-inv-item-info-button-corner-r'/>
    </div>
  );
};

const ItemImage = ({ item }) => {
  const useThirdpartyImageClass = item && item.getSubType() && item.getSubType().includes('mutatio');
  const imageClassName = useThirdpartyImageClass ? 'broadsider-inv-item-image-third-party' : 'broadsider-inv-item-image';

  return (
    <div className='broadsider-inv-item-image-wrapper'>
      <img className={imageClassName} src={item.getImgSource()} />
    </div>
  );
};

const ItemName = ({ item }) => {
  return (
    <div className='broadsider-inv-item-name-label'>{item.getName()}</div>
  );
};

const BroadsiderInventoryItem = ({ onClick, item, isSelected = false, isSlot = false, slot = null, sound = 'hover' }) => {
  const { setSelectedAsset } = useContext(AppContext);
  const { playSFX } = useAudio();
  const iconSrc = isSlot
    ? isSelected
      ? '/assets/arrows_selected.svg'
      : '/assets/arrows.svg'
    : isSelected
      ? '/assets/equip_remove.svg'
      : '/assets/equip_set.svg';

  return (
    <div style={{ width: '100%' }} onClick={() => onClick ? onClick() : false } onMouseEnter={() => sound ? playSFX(sound) : false}>
      <StyledBroadsiderInventoryItem $selected={isSelected || isSlot} $highlighted={isSelected && isSlot}>
        <div className='broadsider-inv-item-border'>
          <div className='broadsider-inv-item-internal-border'>
	    <div className='broadsider-inv-item-content'>
	      <img className='broadsider-inv-item-content-bg' src='/assets/item_bg.png'/>
              <ItemImage item={item} />
              <div className='broadsider-inv-item-name'>
                <div className='broadsider-inv-item-action-icon'>
	          <img src={iconSrc} />
                </div>
                <ItemName item={item} />
              </div>
              {isSlot && (
                <div className='broadsider-inv-item-type'>
                  <div className='broadsider-inv-item-type-name'>{slot.equipped.getType()}</div>
                    <div className='broadsider-inv-item-number'>
                    <span>[</span>
                    <span className='number'>{slot.options.length}</span>
                    <span>]</span>
                  </div>
                </div>
	      )}
              {!isSlot && (
                <div className='broadsider-inv-item-info'>
                  <InfoButton onClick={(e) => {
                    playSFX('button');
                    setSelectedAsset(item);
		    e.stopPropagation();
                  }}/>
                </div> 
              )}
            </div>
          </div>
        </div>
	<div className='broadsider-inv-item-decorator'>
          <div />
        </div>
      </StyledBroadsiderInventoryItem>
    </div>
  );
};
export default BroadsiderInventoryItem;
